/*
 * @Author: your name
 * @Date: 2021-08-26 09:49:59
 * @LastEditTime: 2021-08-31 17:06:25
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/api/home/index.js
 */
// 首页页接口；
import ajax from '@/utils/ajax';

const header = '/web';
// 获取首页推荐内容列表 课程id集合(精选课程)
export const reqRecommend = (terminal, terrace, categoryLabelId) => ajax(`${header}/v1/home-recommend/info?terminal=${terminal}&terrace=${terrace}&categoryLabelId=${categoryLabelId}`);

// 通过产品id获取课程推荐
export const reqRecommendList = (productId) => ajax(`${header}/v1/operation/recommend/course?productId=${productId}`);

// 根据产品id集合获取产品相关信息列表（精选课程）
export const reqProducts = (data, endPoint) => ajax(`${header}/v1/product/home/list/1/${endPoint}?isFilterFrontShow=0`, data, 'POST');

export const reqProductsNew = (data) => ajax(`${header}/v1/product/home/list/new/0/1`, data, 'POST');

//  获取使用中的广告信息（精选课程中广告位，公开课，轮播图）
export const reqAdvertPlaying = (data) => ajax(`${header}/v1/advert/playing/info`, data, 'POST');

// 获取全部课程列表分类
export const reqTypeList = (type) => ajax(`${header}/v1/dictionary/type/${type}`);

// 查询公开课某课程下的直播列表

export const reqOpenCourseLive = (curriculumId, status) => ajax(`${header}/live-broadcast/curriculum?curriculumId=${curriculumId}&status=${status}`);

// 获取全部课程列表
export const reqProductList = (data) => ajax(`${header}/v1/product/new/home/page`, data, 'POST');

// 添加考季
export const reqChoseRecords = (data) => ajax(`${header}/v1/user/exam/choose-records`, data, 'POST');

// 查询最近选择的考季
export const reqArkChoose = () => ajax(`${header}/v1/user/exam/choose-records/pageList`);

// 查询最近选择的考季
export const reqAppVersion = () => ajax(`${header}/v1/dictionary/type/FRONT_END`);
// 首页专业课推荐广告位
export const reqMajorAd = (ids) => ajax(`${header}/v1/home-recommend/info-list?ids=${ids}`);

export const reqNewTypeList = (type, code) => ajax(`${header}/v1/dictionary/detail-by-code?type=${type}&code=${code}`);

// 防伪码验证
export const reqSecurityCode = (code) => ajax(`${header}/v1/tool/security-code/check-authenticity?&code=${code}`);

// 根据广告位id获取对应的产品信息
export const reqAdvertDetail = (id) => ajax(`${header}/v1/advert/detail?id=${id}`);

// 根据直播推荐id获取对应的产品信息
export const reqRecommendDetail = (id) => ajax(`${header}/v1/operation/recommend/detail?id=${id}`);

// 首页热门榜单列表页面评价
export const reqHotEvaluation = () => ajax(`${header}/v1/product-evaluation/hot?pageNum=1&pageSize=100`);

// 首页精品专题课程分页列表
export const reqProtrialCourse = (data) => ajax(`${header}/v1/pro-trial-front/page`, data, 'GET');

// 精品专题课程详情页-推荐课程
export const reqProtrialRecommend = (id) => ajax(`${header}/v1/pro-trial-front/recommend/${id}`, '', 'GET');

// 精品专题课程明细
export const reqProtrialDetail = (data) => ajax(`${header}/v1/pro-trial-front/show/${data}`, '', 'GET');

// 精品专题课程详情页-累加学习次数
export const reqProtrialAccumulate = (id) => ajax(`${header}/v1/pro-trial-front/accumulate/${id}`, '', 'GET');

//获取业务ID编码映射列表
export const reqRelationList = (code) => ajax(`${header}/v1/business-code-relation/list`,code,'POST');




